import React, { useState } from 'react';
import styled from 'styled-components';
import { FaUserCircle } from 'react-icons/fa';

import ProfileModal from '../Components/Profile';

const NavbarGuest = ({    isSidebarExpanded  }) => {
  const [isProfileModalVisible, setProfileModalVisible] = useState(false);


  const handleProfileClick = () => {
    setProfileModalVisible(true);
  };

  const handleCloseModal = () => {
    setProfileModalVisible(false);
  };

  return (
    <NavbarContainer isSidebarExpanded={isSidebarExpanded}>
 <p style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '40%', marginBottom: '10px', color: '#18591d' }}>
    Smart Irrigation, Sustainable Growth.
  </p>
      

      {/* Profile Icon with Account tooltip on hover */}
      <ProfileWrapper onClick={handleProfileClick}>
        <ProfileIconContainer>
          <FaUserCircle style={styles.profileIcon} />
          <TooltipAccount className="tooltip">Account</TooltipAccount>
        </ProfileIconContainer>
      </ProfileWrapper>

      {isProfileModalVisible && <ProfileModal onClose={handleCloseModal} />}
    </NavbarContainer>
  );
};

export default NavbarGuest;

const NavbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(250, 246, 246);
  position: fixed;
  top: 0;
   left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '0px' : '0px')}; 
  width: calc(100% - ${({ isSidebarExpanded }) => (isSidebarExpanded ? '250px' : '10px')});
  padding: 0 10px;
  transition: left 0.3s ease, width 0.3s ease;
  z-index: 1000;
`;


const ProfileWrapper = styled.div`
  position: relative;

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }
`;

const ProfileIconContainer = styled.div`
  cursor: pointer;
  color: #4d4d4d;
  font-size: 24px;
  margin-right: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 2px solid #4d4d4d;
  position: relative;
`;

const TooltipAccount = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 5px;
  transition: opacity 0.3s ease, visibility 0.3s ease;

  ${ProfileWrapper}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

const styles = {
  icon: (isActive) => ({
    fontSize: '24px',
    color: isActive ? '#28a745' : '#4d4d4d',
    marginRight: '20px',
  }),
  searchIcon: {
    fontSize: '15px',
    color: '#4d4d4d',
  },
  profileIcon: {
    fontSize: '25px',
    color: '#4d4d4d',
  },
};
